import LoginForm from "../Components/Login/LoginForm";
import Layout from "../Layout/Layout";

const Login = () => {
  return (
    <Layout>
      <LoginForm />
    </Layout>
  );
};

export default Login;
